// extracted by mini-css-extract-plugin
export default {"main-content":"NRDRUHSHeader_main-content__jNEQm","header-image":"NRDRUHSHeader_header-image__sFeSi"};